import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';

const emailStepSchema = z.object({
  email: z.string().trim().min(1, 'Enter your email address to continue').email('Enter a valid email address'),
});

export type IEmailStepForm = z.infer<typeof emailStepSchema>;

type Props = {
  defaultEmail?: string;
  onSubmit: (data: IEmailStepForm) => Promise<void>;
};

const EmailStepForm = ({ defaultEmail = '', onSubmit }: Props) => {
  const form = useForm<IEmailStepForm>({
    resolver: zodResolver(emailStepSchema),
    defaultValues: { email: defaultEmail },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email address</FormLabel>
              <FormControl>
                <Input {...field} type="email" placeholder="Enter your email address" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button
          type="submit"
          size="lg"
          className="w-full"
          isLoading={form.formState.isSubmitting}
          disabled={form.formState.isSubmitting}
        >
          Sign in
        </Button>
      </form>
    </Form>
  );
};

export default EmailStepForm;
